import React from "react";
import SectionHeader from "../../utilis/SectionHeader";

const AccountSection = () => {
  const content = [
    {
      img: "/image/country-section/usa.png",
      title: "USD - US Dollar",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'fade-up',
    },
    {
      img: "/image/country-section/eu.png",
      title: "EUR - Euro",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'zoom-in',

    },
    {
      img: "/image/country-section/uk.png",
      title: "GBP - British Pound",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'fade-up',

    },
    {
      img: "/image/country-section/canada.png",
      title: "CAD - Canadian Dollar",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'fade-up',

    },
    {
      img: "/image/country-section/australia.png",
      title: "AUD - Aus Dollar",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'zoom-in',

    },
    {
      img: "/image/country-section/japan.png",
      title: "JPY - Japaneese Yen",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'fade-up',
    },
    {
      img: "/image/country-section/india.png",
      title: "INR - Indian Rupee",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'fade-up',

    },
    {
      img: "/image/country-section/newzland.png",
      title: "NZD - NZ Dollar",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'zoom-in',

    },
    {
      img: "/image/country-section/france.png",
      title: "CHF - Swiss Franc",
      content: "Adipiscing eliId nque diraam nim etrous porta vierra dolore.",
      animation : 'fade-up',

    },
  ];

  return (
    <div className="account_section section-padding">
      <div className="container px-sm-1 px-4">
        {/* HEADING SECTION */}
        <div className="row padding-bottom">
          <div className="col-lg-6 col-sm-10 mx-auto" data-aos="zoom-in">
            <SectionHeader
              subTitle="CURRENCY PROFILE"
              title="Get These Local Account Details Just Like Pay A Local"
            />
          </div>
        </div>

        {/* CONTENT SECTION */}
        <div className="row g-4">
          {content.map((element, index) => {
            return (
              <div className="col-lg-4 col-sm-6 " key={index} data-aos={element.animation} >
                <div className="account_card d-flex p-4 shadow-sm">
                  <div className="account_img me-4">
                    <img src={element.img} className="img-fuid" alt="" />
                  </div>
                  <div className="account_content">
                    <h5 className="fw-800 text-black mb-3 account_title transition">{element.title}</h5>
                    <p className="text-color transition account_content">{element.content}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AccountSection;
